import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
`;

export const SummaryValue = styled.div`
  font-family: ${defaultTheme.fonts.title};
  font-size: 1.4rem;
  font-weight: 700;
  color: ${defaultTheme.colors.danger};
`;

export const SummaryLabel = styled.div`
  font-size: 0.75rem;
  color: ${defaultTheme.colors["gray-300"]};
`;
